import { ChangeEvent, FC } from 'react';
import { JobCountQuery } from '@doda/common/src/services/getJobCountAPI';
import { EmploymentStatusHooksType } from 'components/SearchConditionSettingForm/types';
import { SearchCheckboxItem } from 'components/SearchCheckboxList';
import styles from './index.module.scss';

/**
 * 検索条件設定コンポーネント 雇用形態 Props
 */
interface Props {
  /** 雇用形態のフックタイプ */
  employmentStatus: EmploymentStatusHooksType;
  /** 求人数を更新するための関数 */
  updateJobCount: (currentCondition?: JobCountQuery) => Promise<void>;
}

/**
 * 検索条件設定コンポーネント 雇用形態
 *
 * @param {Props} props - 雇用形態の検索条件設定に必要なプロパティ
 * @returns {JSX.Element} Reactコンポーネント
 */
export const EmploymentContents: FC<Props> = ({
  employmentStatus,
  updateJobCount,
}) => {
  const { updateIsCheckEmploymentStatusList, employmentStatusList } =
    employmentStatus;

  /**
   * チェックボックスの変更ハンドラー
   *
   * @param {ChangeEvent<HTMLInputElement>} event - チェックボックスの変更イベント
   * @param {string} selectedValue - 選択された値
   */
  const onChangeCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    selectedValue: string
  ) => {
    const checkedList = updateIsCheckEmploymentStatusList(event, selectedValue);
    updateJobCount({ employmentStatus: checkedList });
  };

  return (
    <div className={styles.searchConditionSettingForm__employmentContents}>
      <ul className={styles.searchCheckboxList__container}>
        {employmentStatusList.map(({ id, name, value, isChecked }) => (
          <li key={id}>
            <SearchCheckboxItem
              title={name}
              value={value}
              isChecked={isChecked}
              onChange={(event) => onChangeCheckbox(event, value)}
              size="L"
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
